import React, { useContext, useEffect } from "react";
import { styled } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import { Container, Typography, Grid, CircularProgress } from "@mui/material";
//@ts-ignore
import { Player } from "../common/player";
import { PlayerContext } from "../../store/PlayerContext";

/**
 * PM5 T2 (money path, batch "freetrial-buynow") — converted from MUI v4 +
 * `makeStyles` to MUI v5+ `styled`/`sx`.
 * See docs/epics/pm5-mui-v5-migration.md §3 (T2) and docs/mui-conversion-guide.md.
 *
 * The preview-video block on /free-trial. Styling-only conversion: the
 * `PlayerContext` calls, the effect dependencies and the `<Player>` props are
 * untouched. `common/player` itself is NOT converted here — it is a
 * performance-critical escalation class scheduled for T4.
 *
 * DEAD RULES DROPPED (guide §1.2 row 1): the v4 `useStyles` object declared 12
 * keys, of which four were ever referenced from the JSX (`background`, `title`,
 * `titleLarge`, `videoPlayerWrapper`). `button`, `secondaryButton`,
 * `videoContainer`, `playerWrapper`, `player`, `videoPlayer` and `playIcon`
 * were never applied to an element, so they rendered nothing.
 */

// was: useStyles().background — a bare <div>, which has no `sx` prop.
const Background = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.ffNavyLighter,
  padding: theme.spacing(5, 0, 6, 0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(8, 0, 10, 0),
  },
}));

// was: useStyles().title
const titleSx = (theme: Theme) => ({
  letterSpacing: "-2px",
  fontSize: "2rem",
  lineHeight: "2.2rem",
  fontWeight: 600,
  textShadow: "-2px 2px 2px #171717",
  "& span": {
    color: "background.ffGreen",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "3rem",
    lineHeight: "3.2rem",
  },
});

// was: useStyles().titleLarge
const titleLargeSx = (theme: Theme) => ({
  letterSpacing: "-2px",
  fontSize: "2.8rem",
  lineHeight: "2.8rem",
  fontWeight: 600,
  textShadow: "-2px 2px 2px #171717",
  [theme.breakpoints.up("sm")]: {
    fontSize: "5.4rem",
    lineHeight: "5rem",
  },
});

// was: useStyles().videoPlayerWrapper
const videoPlayerWrapperSx = {
  position: "relative",
  margin: "20px 0",
};

const Video = () => {
  // Slug of Mammy Challenge Video
  const videoId = "free-trial-compilation"; // <-- New slug required

  const { loadPreviewVideo, currentPreviewVideo, clearCurrentPreviewVideo } =
    useContext(PlayerContext);

  useEffect(() => {
    return () => {
      clearCurrentPreviewVideo();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (videoId) {
      loadPreviewVideo(videoId, "slug");

      console.log(currentPreviewVideo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoId]);

  return (
    <>
      <Background>
        <Container maxWidth="md" fixed>
          {/* v5+ Grid: `item` is gone and the breakpoint props collapse into
              `size`. No `spacing` on this container, so widths are unchanged. */}
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Typography variant="h2" sx={titleSx}>
                We Produce <span>Real World</span>
              </Typography>
              <Typography variant="h2" sx={titleLargeSx}>
                Agricultural Content
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={videoPlayerWrapperSx}>
              {currentPreviewVideo ? (
                <Player
                  userId={undefined}
                  video={currentPreviewVideo}
                  type="preview"
                />
              ) : (
                <CircularProgress color="primary" />
              )}
            </Grid>
          </Grid>
        </Container>
      </Background>
    </>
  );
};

export default Video;
